import * as R from 'ramda';

export const getGenderFromProfile = userProfile =>
    R.pipe(
        R.prop('publisher_type'),
        R.ifElse(
            R.isNil,
            R.always(null),
            R.pipe(
                R.split('_'),
                R.last
            )
        )
    )(userProfile);

export const getUserScoreClass = score => {
    if (score >= 0 && score <= 25) {
        return 'level-one';
    }
    if (score >= 26 && score <= 40) {
        return 'level-two';
    }
    if (score >= 41 && score <= 59) {
        return 'level-three';
    }
    if (score >= 60 && score <= 80) {
        return 'level-four';
    }
    if (score >= 81 && score <= 90) {
        return 'level-five';
    }
    if (score >= 91 && score <= 100) {
        return 'level-six';
    }
    return '';
};



// WEBPACK FOOTER //
// ./common/user_helper.js